/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

 import {default as CellOperate} from "../../../../components/agGridComponent/cellOperate";
 import {ColDefCustom, default as AgGridVueCustomTsx} from "../../../../components/agGridCustom/agGridVueCustomTsx";
 import _ from 'lodash'
 import ListPageService from "../../../../types/ListPage";
 import override from "../../../../dectorators/override";
 import {DateTimeUtil} from "../../../../util/dateTimeUtil";
 import {QueryFormVOI} from "../../../../components/queryForm/queryForm";
 import AlarmSearchApi, { AlarmSearchDOI } from '../../../alarmManage/alarmSearch/api/alarmSearchApi'
 import AlarmSearchTestApi from '../api/testApi'
 import AlarmSearch from '../alarmSearch';
 import AreaCascader from 'src/components/areaCascader/areaCascader';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumAlarmType from 'src/enums/enumAlarmType';
 import EnumNoticeType from 'src/enums/enumNoticeType';
 import DatePicker from 'src/types/iview/DatePicker';
 import Input from 'src/types/iview/Input';
 import EnumStationType from 'src/enums/enumStationType';
 import alertNoticeModal from '../../../alarmManage/alarmSearch/noticeModal'
 import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
 import alertAlarmSearchModal from '../alarmSearchModal';
 import { Toast } from 'src/util/toast';
 
 export default class AlarmSearchService extends ListPageService {
     ctx: AlarmSearch;
     
     get type() {
         return EnumStationType.findCode(this.ctx.$route.params.type).getId();
     }
 
     constructor (ctx: AlarmSearch) {
         super()
         this.ctx = ctx
     }
 
     @override
     createColumns (): ColDefCustom [] {
         let t = this
         return [
             {
                 headerName: '区域',
                 field: 'area',
                 minWidth: 190,
                 cellRenderer(params) {
                     let data: AlarmSearchDOI.RowDataI = params.data;
                     return data.province_name+data.city_name+data.district_name
                 }
             },
             {
                 headerName: '站点名称',
                 field: 'device_name',
                 minWidth: 120
             },
             {
                 headerName: '报警时间',
                 field: 'create_time',
                 minWidth: 160,
                 // cellRenderer (params) {
                 // 	let data: AlarmSearchDOI.RowDataI = params.data
                 // 	return DateTimeUtil.GMTToStr(data.create_time)
                 // }
             },
             {
                 headerName: '报警类型',
                 field: 'type',
                 minWidth: 100,
                 cellRenderer (params) {
                     let data: AlarmSearchDOI.RowDataI = params.data
                     return EnumAlarmType.findId(data.type).getName()
                 }
             },
             {
                 headerName: '状态',
                 field: 'orderDate',
                 minWidth: 100,
                 cellRenderer (params) {
                     let data: AlarmSearchDOI.RowDataI = params.data
                     return EnumNoticeType.findId(data.status).getName()
                 }
             },
             {
                 headerName: '通知状态',
                 field: 'reportDate',
                 minWidth: 100,
                 cellRendererFramework: CellRenderTsx,
                 cellRendererFrameworkOpt:{
                     cellRender(h, params) {
                         let data: AlarmSearchDOI.RowDataI = params.data
                         return <div style={{color:data.status==EnumNoticeType.UnNotice.getId()?"#E2014A":'#fff'}}>{EnumNoticeType.findId(data.status).getName()}</div>
                     }
                 }
             },
             {
                 headerName: '操作',
                 field: 'operate',
                 minWidth: 100,
                 maxWidth: 100,
                 cellRendererFramework: CellOperate,
                 cellRendererFrameworkOpt: [
                     {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: AlarmSearchDOI.RowDataI = params.data;
                            debugger
                            await t.delete(data.id);
                        },
                    },
                 ]
             },
         ]
     }
 
     // @override
     // createBtnGroup (): Array<IconBtnItem> {
     // 	let t = this
     // 	return [
     // 		{
     // 			icon: 'md-return-left',
     // 			type: 'error',
     // 			text: '退回',
     // 			onClick: t.operate.bind(t)
     // 		}
     // 	]
     // }

     @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertAlarmSearchModal();
                    if (res) {
                        t.searchTable();
                    }
                },
            },
        ];
    }

    async delete(ids: number) {
        let { code } = await AlarmSearchTestApi.delete({ id: ids });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }
 
     @override
     creatQueryForm(): QueryFormVOI.DateItemType[] {
         return [
            {
                component: CommonSelect,
                label: '站点类型',
                field: 'types',
                labelWidth: 60,
                width:160,
                props: { value: 0, dataSource: EnumStationType.getList() },
            },
             {
                 component: AreaCascader,
                 label: '区域',
                 field: 'area：',
                 width: 320,
                 labelWidth: 50,
                 dealParam(value) {
                     return {
                         province_id: value[0],
                         city_id: value[1],
                         district_id: value[2],
                     };
                 },
                 props: { value: [], type: this.type },
             },
             {
                 component: CommonSelect,
                 label: '报警类型：',
                 field: 'type',
                 props: { value: null, dataSource: EnumAlarmType.getList() },
             },
             {
                 component: CommonSelect,
                 label: '通知类型：',
                 field: 'infrom_status',
                 props: { value: null, dataSource: EnumNoticeType.getList() },
             },{
                 component: DatePicker,
                 label: '时间',
                 field: 'time',
                 labelWidth: 50,
                 width: 230,
                 realField: ['start_time','end_time'],
                 props: {value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间'},
             },
             {
                 component: Input,
                 label: '',
                 labelWidth: 20,
                 width: 140,
                 field: 'device_name',
                 props: { value: '', placeholder: '请输入站点名称' },
             },
         ];
     }
 
 
     @override
     initSearchParams (): void {
         this.ctx.searchParams = {
             ...this.ctx.queryForm.getQueryObj<AlarmSearchDOI.QueryRowDataParamsI>(),
            //  site_type: this.ctx.searchParams["types"],
             page_index: this.ctx.currentPage,
             page_size: this.ctx.pageSize,
         }
         this.ctx.searchParams['site_type'] = this.ctx.searchParams.types;
         this.ctx.currentPage = 1
     }
 
     @override
     async searchTable () {
         let ctx = this.ctx
         let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
         ag.showLoading()
         let {code, data} = await AlarmSearchApi.searchList({
             ...ctx.searchParams,
             page_size: ctx.pageSize,
             page_index: ctx.currentPage
         })
         ag.hideLoading()
 
         if (code === 0) {
             ctx.rowData = data.data_info || [];
             ctx.total = data.page_count
         }
     }
 
 }
 